import React, { useEffect, useState } from 'react';
import { BiErrorCircle } from 'react-icons/bi';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { Alert, Spinner } from 'reactstrap';
import { employee_dashboard_actions_helper } from '../../../../../../actions/actions_helper';
import { fail_retrieve_loading_order_list, loading_retrieve_loading_order_list, reset_retrieve_loading_order_list, success_retrieve_loading_order_list } from '../../../../../../reducers/dashboard_reducers/loading_orders/retrieve_loading_order_list_Slice';
import { CREATE_PHYSICAL_DELIVERY_NOTE_TICKET_ACCESS_DENIED_MSG, CREATE_PHYSICAL_DELIVERY_NOTE_TICKET_ERR_MSG, CREATE_PHYSICAL_DELIVERY_NOTE_TICKET_SUCCESS_MSG, RETRIEVE_LOADING_ORDER_LIST_ACCESS_DENIED_MSG, RETRIEVE_LOADING_ORDER_LIST_ERR_MSG, RETRIEVE_LOADING_ORDER_LIST_SUCCESS_MSG } from '../../../../../../constants/success_error_messages_consts';
import { CREATE_WAREHOUSE_DELIVERY_NOTE_API, RETRIEVE_INITAL_DELIVERY_NOTE_LOADING_ORDERS } from '../../../../../../api/api_data';
import * as app_consts from "../../../../../../constants/react_app_consts";
import { useSelector } from 'react-redux';
import { messageToast } from '../../../../../../utils/Utils';
import { BlockHead, BlockTitle, Button, Col, Icon, Row, RSelect } from '../../../../../../components/Component';
import { getSelectedOption, removeWhitespaceAndCapitalize } from '../../../../../../utils/functionalUtils';
import TextInput from '../../../../../components/inputs/TextInput';
import { fail_create_delivery_note_ticket, loading_create_delivery_note_ticket, reset_create_delivery_note_ticket, success_create_delivery_note_ticket } from '../../../../../../reducers/dashboard_reducers/delivery_notes/create_delivery_note_ticket_Slice';

const initialState = { loading_order_ref_no: "", owner: "", contact_mobile: "", contact_person: "", loading_order_type: "", transporter_name: "", truck_driver_name: "", truck_licence_plate: "", trailer_one: "", trailer_two: "", comments: "", delivery_location: "", contract_number: "" };

const AddDNModal = ({ successFunction, setModalLoading, openModal }) => {
  // Variables
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [formData, setFormData] = useState(initialState);
  const [page_data, setPageData] = useState([]);
  const [loading_order_options, setLoadingOrderOptions] = useState([]);
  const [delivery_location_list, setDeliveryLocationList] = useState([]);
  const [submitError, setSubmitError] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);

  // UseEfffect
  useEffect(() => {
    setFormData(initialState);
    if (openModal)
    {
      retrieve_loading_order_list_func();
    }
  }, [openModal]);

  // Retrieve Delivery Notes Tickets
  const retrieve_loading_order_list_func = () => {
    dispatch(
      employee_dashboard_actions_helper(
        loading_retrieve_loading_order_list,
        success_retrieve_loading_order_list,
        fail_retrieve_loading_order_list,
        RETRIEVE_LOADING_ORDER_LIST_ERR_MSG,
        RETRIEVE_LOADING_ORDER_LIST_SUCCESS_MSG,
        app_consts.GET,
        RETRIEVE_INITAL_DELIVERY_NOTE_LOADING_ORDERS,
        null,
        RETRIEVE_LOADING_ORDER_LIST_ACCESS_DENIED_MSG
      )
    );
  };

  // Listen to Loading Order Changes
  const retrieve_loading_order_list = useSelector((state) => state.retrieve_loading_order_list.retrieve_loading_order_list);
  // 
  useEffect(() => {
    if (retrieve_loading_order_list.status !== app_consts.IDLE)
    {
      if (retrieve_loading_order_list.status === app_consts.LOADING)
      {
        setError("");
        setLoading(true);
      } else
      {
        setLoading(false);
        if (retrieve_loading_order_list.status === app_consts.FAIL)
        {
          setError(retrieve_loading_order_list.message);
          messageToast(RETRIEVE_LOADING_ORDER_LIST_ERR_MSG, app_consts.FAIL);
        } else if (retrieve_loading_order_list.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_loading_order_list.data);

          const loading_order_data = retrieve_loading_order_list.data?.map((data) => { return { label: `${data?.loading_order_ref_no} - ${data?.owner}`, value: data?.loading_order_ref_no }; });

          setLoadingOrderOptions(loading_order_data);
        }
        dispatch(reset_retrieve_loading_order_list());
      }
    }
  }, [retrieve_loading_order_list]);

  const handleLoadingOrderChange = (value, label) => {
    const filteredData = page_data?.find((data) => data?.loading_order_ref_no === value);

    const delivery_locations = Array.from(
      new Map(
        filteredData?.delivery_locations?.map(data => [data?.location_name, {
          label: data?.location_name,
          value: data?.location_name
        }])
      ).values()
    );

    setDeliveryLocationList(delivery_locations);

    setFormData({ ...formData, loading_order_ref_no: value, loading_order_type: filteredData?.loading_order_type, contact_mobile: filteredData?.contact_mobile, contact_person: filteredData?.contact_person, owner: filteredData?.owner, transporter_name: filteredData?.transporter_name, truck_driver_name: filteredData?.truck_driver_name, truck_licence_plate: removeWhitespaceAndCapitalize(filteredData?.truck_license_plate || ""), trailer_one: removeWhitespaceAndCapitalize(filteredData?.trailer_one || ""), trailer_two: removeWhitespaceAndCapitalize(filteredData?.trailer_two || "") });
  };

  const handleChange = (e) => {
    let change_value = e.target.value;
    if (e.target.name === "truck_licence_plate" || e.target.name === "trailer_one" || e.target.name === "trailer_two")
    {
      change_value = removeWhitespaceAndCapitalize(e.target.value);
    }
    setFormData({ ...formData, [e.target.name]: change_value });
  };

  const handleCreateDN = () => {
    setSubmitError("");
    dispatch(
      employee_dashboard_actions_helper(
        loading_create_delivery_note_ticket,
        success_create_delivery_note_ticket,
        fail_create_delivery_note_ticket,
        CREATE_PHYSICAL_DELIVERY_NOTE_TICKET_ERR_MSG,
        CREATE_PHYSICAL_DELIVERY_NOTE_TICKET_SUCCESS_MSG,
        app_consts.POST,
        CREATE_WAREHOUSE_DELIVERY_NOTE_API,
        formData,
        CREATE_PHYSICAL_DELIVERY_NOTE_TICKET_ACCESS_DENIED_MSG
      )
    );
  };


  // Listen to Create Delivery Note Reducer
  const create_delivery_note_ticket = useSelector((state) => state.create_delivery_note_ticket.create_delivery_note_ticket);

  useEffect(() => {
    if (create_delivery_note_ticket.status !== app_consts.IDLE)
    {
      if (create_delivery_note_ticket.status === app_consts.LOADING)
      {
        setSubmitError("");
        setSubmitLoading(true);
      } else
      {
        setSubmitLoading(false);
        if (create_delivery_note_ticket.status === app_consts.FAIL)
        {
          setSubmitError(create_delivery_note_ticket.message);
          messageToast(create_delivery_note_ticket.message, app_consts.FAIL);
        } else if (create_delivery_note_ticket.status === app_consts.SUCCESS)
        {
          successFunction();
          messageToast(CREATE_PHYSICAL_DELIVERY_NOTE_TICKET_SUCCESS_MSG, app_consts.SUCCESS);
          navigate(`/dashboard/delivery_notes/${create_delivery_note_ticket.data?.delivery_note_ref_number}`);
        }
        dispatch(reset_create_delivery_note_ticket());
      }
    }
  }, [create_delivery_note_ticket]);

  return (
    <>
      {
        loading ?
          <>
            <div className='p-5 d-flex align-center justify-center'>
              <Spinner />
            </div>
          </>
          :
          <>
            {
              error && error.length > 0 ?
                <>
                  <div className="mt-3 p-5 text-soft alert-icon text-center fw-bold fs-15px">
                    <BiErrorCircle className="text-danger fs-3" />
                    <p>{error}</p>
                  </div>
                </>
                :
                <>
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                    }}
                  >
                    <Row className="g-4">
                      <Col size={4}>
                        <div className="form-group">
                          <label className="form-label" htmlFor="uom">
                            Loading Order<span className='text-danger pr-2'>{` *`}</span>
                          </label>
                          <div className="w-100 form-control-wrap d-flex flex-row justify-content-between align-items-center">
                            <div className="w-100">
                              <RSelect
                                options={loading_order_options}
                                className="w-100"
                                placeholder="Search"
                                id="loading_order_ref_no"
                                onChange={(e) => { handleLoadingOrderChange(e.value, e.label); }}
                                isDisabled={loading}
                                value={getSelectedOption(formData?.loading_order_ref_no, loading_order_options)}
                              />
                            </div>
                          </div>
                        </div>
                      </Col>
                      <TextInput
                        colSize={4}
                        label="Contract Number"
                        type="text"
                        id_val="contract_number"
                        value={formData.contract_number}
                        name="contract_number"
                        handleChange={handleChange}
                        required
                      />
                      {
                        formData.loading_order_ref_no &&
                        <>
                          <TextInput
                            colSize={4}
                            label="Loading Order Type"
                            type="text"
                            id_val="loading_order_type"
                            value={formData.loading_order_type?.toUpperCase()}
                            name="loading_order_type"
                            disabled
                          />
                          <TextInput
                            colSize={4}
                            label="Owner"
                            type="text"
                            id_val="owner"
                            value={formData.owner?.toUpperCase()}
                            name="owner"
                            disabled
                          />
                          <TextInput
                            colSize={4}
                            label="Contact Person"
                            type="text"
                            id_val="contact_person"
                            value={formData.contact_person?.toUpperCase()}
                            name="contact_person"
                            disabled
                          />
                          <TextInput
                            colSize={4}
                            label="Contact Mobile"
                            type="text"
                            id_val="contact_mobile"
                            value={formData.contact_mobile}
                            name="contact_mobile"
                            disabled
                          />
                          <TextInput
                            colSize={4}
                            label="Transporter"
                            type="text"
                            id_val="transporter_name"
                            value={formData.transporter_name}
                            handleChange={handleChange}
                            name="transporter_name"
                            required
                          />
                          <TextInput
                            colSize={4}
                            label="Truck Driver"
                            type="text"
                            id_val="truck_driver_name"
                            value={formData.truck_driver_name}
                            handleChange={handleChange}
                            name="truck_driver_name"
                            required
                          />
                          <TextInput
                            colSize={4}
                            label="Truck Reg No"
                            type="text"
                            id_val="truck_licence_plate"
                            value={formData.truck_licence_plate}
                            handleChange={handleChange}
                            name="truck_licence_plate"
                            required
                          />
                          <TextInput
                            colSize={4}
                            label="Trailer Reg 1 (Optional)"
                            type="text"
                            id_val="trailer_one"
                            value={formData.trailer_one}
                            handleChange={handleChange}
                            name="trailer_one"
                          />
                          <TextInput
                            colSize={4}
                            label="Trailer Reg 2 (Optional)"
                            type="text"
                            id_val="trailer_two"
                            value={formData.trailer_two}
                            handleChange={handleChange}
                            name="trailer_two"
                          />
                          {/* <BlockHead>
                            <BlockTitle tag="h6">Delivery Location</BlockTitle>
                          </BlockHead> */}
                          <Col size={4}>
                            <div className="form-group">
                              <label className="form-label" htmlFor="uom">
                                Delivery Location<span className='text-danger pr-2'>{` *`}</span>
                              </label>
                              <div className="w-100 form-control-wrap d-flex flex-row justify-content-between align-items-center">
                                <div className="w-100">
                                  <RSelect
                                    options={delivery_location_list}
                                    className="w-100"
                                    placeholder="Search"
                                    id="loading_order_ref_no"
                                    onChange={(e) => { setFormData({ ...formData, ["delivery_location"]: e.value }); }}
                                  />
                                </div>
                              </div>
                            </div>
                          </Col>
                          {/* <TextInput
                            colSize={4}
                            label="Tare Weight (Metric Tonnes)"
                            type="number"
                            id_val="first_weight"
                            value={formData.first_weight}
                            handleChange={handleChange}
                            name="first_weight"
                            onBlur={handleFirstWeightBlur}
                            required
                          /> */}
                          <Col size="12" className="mt-2">
                            <div className="form-group">
                              <label className="form-label text-md" htmlFor="comments">
                                Comments (Optional)
                              </label>
                              <div className="form-control-wrap">
                                <textarea
                                  className="no-resize form-control"
                                  type="textarea"
                                  id="default-textarea"
                                  value={formData.comments}
                                  onChange={handleChange}
                                />
                              </div>
                            </div>
                          </Col>
                          {submitError && (
                            <div className="mt-4">
                              <Alert color="danger" className="alert-icon">
                                {" "}
                                <Icon name="alert-circle" />
                                {submitError}{" "}
                              </Alert>
                            </div>
                          )}
                          <Col xl="12" className="d-flex justify-content-end">
                            <Button
                              onClick={handleCreateDN}
                              size="lg"
                              type="submit"
                              color="primary"
                              disabled={submitLoading || !(formData.loading_order_ref_no && formData.delivery_location && formData.transporter_name && formData.truck_driver_name && formData.truck_licence_plate && formData?.contract_number)}
                            >
                              Generate Delivery Note
                            </Button>
                          </Col>
                        </>
                      }
                    </Row>
                  </form>
                </>
            }
          </>
      }

    </>
  );
};

export default AddDNModal;